import HTTP from "../http";
import Jsona from "jsona";

const dataFormatter = new Jsona();

export default {
  async create(payload) {
    payload.district.rating.rating_min *= 100;
    payload.district.rating.rating_max *= 100;
    payload.district.pricing.price = payload.district.pricing.price
      .toString()
      .replace(".", "");
    payload.district.pricing.price_per_hour = payload.district.pricing.price_per_hour
      .toString()
      .replace(".", "");
    payload.district.pricing.fee = payload.district.pricing.fee
      .toString()
      .replace(".", "");
    payload.district.pricing.fee_per_hour = payload.district.pricing.fee_per_hour
      .toString()
      .replace(".", "");

    let data = {
      data: {
        type: "districts",
        attributes: {
          display_name: payload.district.display_name,
          code: payload.district.code,
          active: true
        },
        relationships: {
          city: {
            attributes: {
              id: payload.city_id
            }
          },
          rating: {
            attributes: payload.district.rating
          },
          pricing: {
            attributes: payload.district.pricing
          }
        }
      }
    };

    try {
      await HTTP.normal.post("/districts", data);
    } catch (e) {
      throw "Ocorreu um erro ao adicionar o distrito";
    }
  },

  async searchByCityAndName(payload) {
    try {
      let results = await HTTP.normal.get(
        `/districts?filter[city_id]=${payload.city.id}&filter[display_name]=${
          payload.district_name
        }`
      );

      if (!results.data.data.length)
        throw `O bairro ${payload.district_name} não foi encontrado na cidade!`;

      return dataFormatter.deserialize(results.data);
    } catch (e) {
      throw typeof e === "string"
        ? e
        : "Ocorreu um erro ao buscar os distritos pela cidade e pelo nome";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/districts.js